/**
 * Scroll to to the top of the listings but only
 * after pagination FacetWP is used.
 *
 * Taking the solution from their docs:
 * https://facetwp.com/help-center/facets/facet-types/pager/
 *
 */

// Set the `enable_scroll` property to true only when a facet like pagination has been used.
document.addEventListener('facetwp-refresh', () => {

  // Facets trigger a 'soft refresh'...
  if ( FWP.soft_refresh == true )  {
    FWP.enable_scroll = true;

  // ... else this will run on first load to default `enable_scroll` to false.
  } else {
    FWP.enable_scroll = false;
  }

});

// After facet results load, check for `.archiveBody` which will contain the listings, and check if scroll is enabled (meaning a facet has been interacted with).
document.addEventListener('facetwp-loaded', () => {

  const archiveBody = document.querySelector('.archiveBody');

  if( archiveBody && FWP.enable_scroll === true ){
    // archiveBody.scrollIntoView({ block: 'start', behavior: 'smooth' });

    // Offset the scroll distance by the height of the sticky header plus an extra 30 or so pixels, otherwise it will scroll to the exact top of the listings and the header will be covering it.
    let scrollDistanceOffset = 30;
    if( document.querySelector('.header') ){
      scrollDistanceOffset += document.querySelector('.header').clientHeight;
    }

    let scrollDistance = archiveBody.getBoundingClientRect().top - scrollDistanceOffset;

    window.scrollBy({
      top: scrollDistance,
      left: 0,
      behavior: 'smooth'
    });

  }

});
